<template>
  <v-container>
    <!-- <div
      v-if="!admin.transfer"
      class="w-100 h-100 d-flex justify-center align-center"
    >
      <h1 class="error--text">You don't have access to this page</h1>
    </div> -->
    <div>
      <h1 class="mb-5">Token Conversion</h1>
      <user-details-min :userId="minUserId" :open.sync="openMin" />
      <v-row>
        <v-col>
          <v-card flat color="white">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search..."
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="arrangedTransaction"
              :loading="loadingTransaction"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 15, 25, 50, 100]
              }"
              @update:items-per-page="updateItemPerPage"
              @update:page="updatePage"
              :server-items-length="apiData.total"
            >
              <template v-slot:[`item.user`]="{ item }">
                <span
                  class="font-weight-medium cursor-pointer primary--text text-capitalize d-block"
                  @click="openMinDialog(item.user_id)"
                >
                  {{ item.user }}
                </span>
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <v-card
                  :color="
                    item.status == 'approved'
                      ? 'success'
                      : item.status == 'pending'
                      ? 'warning'
                      : 'error'
                  "
                  flat
                  rounded="md"
                  outlined
                  class="text-capitalize text-center white--text pa-1"
                >
                  {{ item.status }}
                </v-card>
              </template>
              <template v-slot:[`item.currency`]="{ item }">
                <span class="font-weight-medium">{{ item.currency }}</span>
              </template>
              <template v-slot:[`item.date`]="{ item }">
                <small class="font-weight-medium">{{ item.date }}</small>
              </template>
              <template v-slot:[`item.amount`]="{ item }">
                <span> {{ item.amount }}</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn small depressed @click.stop="selectTransaction(item)"
                  >View Details</v-btn
                >
              </template>
            </v-data-table>
            <!-- <delete-dialog :open.sync="dialogDelete" type="sales" /> -->
            <bonus-details
              :actionProgress.sync="progress"
              :open.sync="transactionOpen"
              :transaction="transaction"
            />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import bonusDetails from '../../../components/bonusDetails'
import bonusApi from '../../../api/admin/bonus'
import { numberWithCommas } from '../../../utils/helpers'
import { mapState } from 'vuex'
import UserDetailsMin from '../../../components/userDetailsMin.vue'
import _ from 'lodash'

export default {
  components: {
    bonusDetails,
    UserDetailsMin
  },
  data: () => ({
    openMin: false,
    minUserId: '',
    progress: 'starting',
    search: '',
    loading: false,
    transactionOpen: false,
    dialogDelete: false,
    headers: [
      {
        text: 'Date',
        align: 'start',
        value: 'date'
      },
      {
        text: 'User',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Token',
        value: 'amount'
      },

      {
        text: 'Status',
        value: 'status'
      },
      {
        text: '',
        value: 'action',
        sortable: false
      }
    ],
    transactions: [],
    transaction: {},
    perPage: 10,
    loadingTransaction: false,
    apiData: {},
    lastPage: 1
  }),
  created() {
    this.getBonusConversions(0)
    this.debounceSearch = _.debounce(this.searchData, 500)
  },
  watch: {
    progress(newValue, oldValue) {
      if (newValue === 'done') {
        this.getBonusConversions()
      }
      this.progress = 'starting'
    },
    search(newValue) {
      if (newValue === '') {
        this.getTransactions(0)
        return
      }
      this.debounceSearch()
    }
  },
  computed: {
    ...mapState({
      admin: (state) => state.admin.admin
    }),
    arrangedTransaction() {
      if (this.transactions.length !== 0) {
        return this.transactions.map((transaction) => ({
          id: transaction._id,
          date: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toDateString(),
          time: new Date(
            transaction.created_at
              ? transaction.created_at
              : transaction.createdAt
          ).toUTCString(),
          user: transaction.user.username,
          user_id: transaction.user._id,
          status: transaction.status,
          transaction_id: transaction.transaction_id,
          amount: numberWithCommas(transaction.amount)
        }))
      }
      return []
    }
  },
  methods: {
    openMinDialog(id) {
      this.openMin = true
      this.minUserId = id
    },
    async searchData() {
      this.loadingTransaction = true
      this.transactionsM = []
      const res = await bonusApi.data().getBonusConversions({
        populate: ['user'],
        type: 'token',
        limit: this.perPage,
        keyword: this.search
      })
      if (res.error) {
        this.$store.dispatch('alert', {
          message:
            res.errorMessage.message ||
            `${res.internalError.message}, please try again`,
          error: true,
          status: true
        })
        return
      }
      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    updatePage(page) {
      if (this.lastPage - page > 2) {
        page = this.lastPage
      }
      this.lastPage = page
      this.getTransactions((page - 1) * this.perPage)
    },
    updateItemPerPage(count) {
      this.perPage = count
      this.getTransactions((this.lastPage - 1) * this.perPage)
    },
    async getBonusConversions(length) {
      this.loading = true
      const res = await bonusApi.data().getBonusConversions({
        populate: ['user'],
        type: 'token',
        limit: this.perPage,
        offset: length
      })

      this.transactions = res.data.data.data
      this.apiData = res.data.data.meta
      this.loadingTransaction = false
    },
    selectTransaction(transx) {
      const transaction = this.transactions.find((trx) => trx._id === transx.id)

      this.transaction = {
        ...transaction,
        user: transaction.user,
        date: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toDateString(),
        time: new Date(
          transaction.created_at
            ? transaction.created_at
            : transaction.createdAt
        ).toTimeString(),
        status: transaction.status,
        transactionInfo: [
          {
            title: 'Transaction Type',
            text: `Token Bonus Conversion`
          },
          {
            title: 'Reason',
            text: transaction.remarks ? transaction.remarks : ''
          },
          {
            title: 'Amount',
            text: `${numberWithCommas(transaction.amount)}`
          },
          {
            title: 'Actioned At',
            text: new Date(
              transaction.actioned_at
                ? transaction.actioned_at
                : transaction.actionedAt
            ).toUTCString()
          }
        ]
      }
      this.transactionOpen = true
    }
  }
}
</script>

<style></style>
